import Modal from "react-modal";
import { custom, handleInput } from "../../../classes/functions";

export default function ModalPeriodFilters({showModalPeriodFilters, operationsFilters, getPeriods}){
    return (
        <Modal
        isOpen={showModalPeriodFilters.state}
        onRequestClose={() => showModalPeriodFilters.setState(false)}
        style={custom("33.3%", "33.3%")}
        contentLabel="Filtros do gráfico de períodos"
        ariaHideApp={false}
      >
        <div className="period-filter">
          <div className="period-filter__filters">
            <div className="period-filter___filter-section">
              <div className="period-filter____filter">
                <label>Data de:</label>
                <input type="date" name="dataDe" value={operationsFilters?.state?.dataDe} onBlur={getPeriods} onChange={(e) => {handleInput(operationsFilters?.setState, e); localStorage.setItem("operationsDateFrom", e.target.value)}}/>
              </div>
              <div className="period-filter____filter">
                <label>Data Até:</label>
                <input type="date" name="dataAte" value={operationsFilters?.state?.dataAte} onBlur={getPeriods} onChange={(e) => {handleInput(operationsFilters?.setState, e); localStorage.setItem("operationsDateUntil", e.target.value)}}/>
              </div>
            </div>
            <div className="period-filter___filter-section">
              <div className="period-filter____filter">
                <label>Característica:</label>
                <select type="text" name="caracteristica" placeholder="Característica" value={operationsFilters?.state?.caracteristica} onChange={(e) => {handleInput(operationsFilters?.setState, e); localStorage.setItem("operationsFeature", e.target.value)}}>
                  <option>Selecione</option>
                  <option value="001">Cost Center</option>
                  <option value="002">Main Code</option>
                  <option value="003">Sub Code</option>
                </select>
              </div>
              <div className="period-filter____filter">
                <label>Valor:</label>
                <input type="text" name="valor" placeholder="Valor" value={operationsFilters?.state?.valor} onChange={(e) => {handleInput(operationsFilters?.setState, e); localStorage.setItem("operationsValue", e.target.value)}}/>
              </div>
            </div>
          </div>
          <div className="period-filter__buttons">
            <button className="period-filter___button" onClick={() => {getPeriods(); showModalPeriodFilters.setState(false)}}>Confirmar</button>
            <button className="period-filter___button" id="button-close" onClick={() => showModalPeriodFilters.setState(false)}>Fechar</button>
          </div>
        </div>
      </Modal>
    )
}